import React, { useState } from "react";
import DatePicker from "react-datepicker";

import "./AnnualCalendar.scss";


const AnnualCalendar = (props) => {

    const [startDate] = useState(null);

    const year = new Array(12).fill(null);
    const month = year.map((e, i) => {
        const tempMonth = e + i + 1;
        return `${props.year}/` + tempMonth + "/01";
    });

    const highlightWithRanges = Object.entries(props.type.data || {}).map(([className, dates]) => ({
        [`react-datepicker__day--highlighted-${className}`]: dates,
    }));

    const dynamicStyles = (props.legends || [])
        .map(({ color }) => {
            const className = `color-${color.replace("#", "")}`;
            return `
                .TEST .react-datepicker__day--highlighted-${className} {
                    background: ${color};
                    color: #0E0E0F;
                }
            `;
        })
        .join("\n");

    return (
        <>
            <style>{dynamicStyles}</style>
            <div className="annual-calendar">
                <div className="annual-calendar__header">
                    <span className="annual-calendar__header__span">
                        {props.type.type}
                    </span>
                </div>
                <div style={{
                    margin: "20px 50px",
                }} className={"cross-table-controller"}>
                    <ul className={"cross-table-controller__legend"}>
                        {
                            props.legends && props.legends.length ?
                                props.legends.map((legend, i) => {
                                    return (
                                        <div key={i} className="table-container__legend ">
                                            <div style={{
                                                backgroundColor: legend.color,
                                                backgroundImage: "none",
                                                opacity: 1,
                                            }}
                                                 className="table-container__legend__color-item"></div>
                                            <div>— {"  "+`  ${legend.name}`}
                                            </div>
                                        </div>
                                    );
                                })
                                : null
                        }
                    </ul>
                </div>
                <div className="annual-calendar__month-container">
                    {year.map((e, i) => {
                        return (
                            <div className="annual-calendar__month" key={i}>
                                <DatePicker
                                    calendarClassName="TEST"
                                    locale={"ru"}
                                    readOnly
                                    selected={startDate}
                                    fixedHeight
                                    disabled
                                    highlightDates={highlightWithRanges}
                                    disabledKeyboardNavigation
                                    openToDate={new Date(month[i])}
                                    inline
                                    dayClassName={(date) => {
                                        const today = new Date();
                                        today.setHours(0, 0, 0, 0);
                                        if (date < today) return "day--past";
                                        return null;
                                    }}
                                    minDate={
                                        props.disableOtherMonth
                                        && props.year
                                        && new Date(props.year, i, 1)
                                    }
                                    maxDate={
                                        props.disableOtherMonth
                                        && props.year
                                        && new Date(props.year, i + 1, 0)
                                    }
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default AnnualCalendar;
